"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchLocationBody = exports.publishAdBody = exports.pauseBody = exports.createCampaignBody = exports.createAdSetBody = exports.editAdSetBody = exports.editAdBody = exports.createAdBody = exports.quoraHeaders = exports.HASH_URL = exports.FORMKEY_URL = exports.VALIDATE_ANSWER_URL = exports.PAUSE_AD_URL = exports.SEARCH_QUESTION_URL = exports.SEARCH_TOPIC_URL = exports.SEARCH_LOCATION_URL = exports.PUBLISH_AD_URL = exports.CREATE_CAMPAIGN_URL = exports.CREATE_AD_SET_URL = exports.CREATE_AD_URL = exports.EDIT_ADSET_URL = exports.EDIT_AD_URL = exports.SEARCH_QUESTION_HASH_REGEX = exports.SEARCH_TOPIC_HASH_REGEX = exports.SEARCH_HAS_SUGGESTED_BID_REGEX = exports.SEARCH_LOCATION_HASH_REGEX = exports.SEARCH_HASH_REGEX = exports.PUBLISH_AD_HASH_REGEX = exports.CREATE_CAMPAIGN_HASH_REGEX = exports.CREATE_AD_SET_HASH_REGEX = exports.EDIT_ADSET_HASH_REGEX = exports.EDIT_AD_HASH_REGEX = exports.CREATE_AD_HASH_REGEX = exports.PAUSE_HASH_REGEX = exports.AUDIENCE_REGEX = exports.ANSWER_REGEX = exports.PlacementPrefixMap = exports.DeviceAndBrowserPrefixMap = exports.QUORA_OPT_TARGETING_TYPE = exports.QUORA_OPT_PLACEMENT = exports.QUORA_OPT_DEVICE_AND_BROWSER = exports.QUORA_OPT_CTA = exports.QUORA_OPT_CREATIVE_TYPE = exports.ConversionEventToPixelId = exports.QUORA_OPT_CONVERSION_EVENT = exports.ConversionObjectiveToQuoraEnum = exports.QUORA_OPT_CONVERSION_OBJECTIVE = exports.AdDeliveryToPricingType = exports.QUORA_OPT_AD_DELIVERY = exports.PLATFORMS = void 0;
exports.CAMPAIGN_NAME_TEMPLATE = exports.AD_SET_NAME_TEMPLATE = exports.AD_NAME_TEMPLATE = exports.InputTitles = exports.Placement = exports.MobileDevice = exports.Gender = exports.Browser = exports.QuoraAdTypes = exports.QuoraDeliveryMap = exports.suggestedBidBody = exports.searchBody = exports.answerBody = exports.searchQuestionBody = exports.searchTopicBody = void 0;
exports.PLATFORMS = ['rumble', 'quora', 'taboola'];
/**
 * INPUT OPTIONS (DROPDOWN)
 */
exports.QUORA_OPT_AD_DELIVERY = [
    'Cost per click',
    'Cost per 1000 impressions',
    'Optimise for leads',
    'Optimise for video views',
    'Optimise for conversions',
];
exports.AdDeliveryToPricingType = {
    'Cost per click': 'cpc',
    'Cost per 1000 impressions': 'cpm',
    'Optimise for video views': 'cpv',
    'Optimise for leads': 'ocpm',
    'Optimise for conversions': 'ocpm',
};
exports.QUORA_OPT_CONVERSION_OBJECTIVE = [
    'Traffic',
    'Conversions',
    'Video views',
    'Awareness',
    // 'Lead generation',
    'App installs',
];
/**
 * Official quora enum mappings
 * @see https://coda.io/d/Titan_d4Scg-LB90m/Quora-Ads-Dashboard_sucFy#_lufqZ
 */
exports.ConversionObjectiveToQuoraEnum = {
    Traffic: 'website_traffic',
    Conversions: 'website_conversions',
    'Video views': 'video_views',
    Awareness: 'awareness',
    // 'Lead generation': 'lead_generation',
    'App installs': 'app_install',
};
exports.QUORA_OPT_CONVERSION_EVENT = [
    'Generic',
    'App Install',
    'Purchase',
    'Generate Lead',
    'Complete Registration',
    'Add Payment Info',
    'Add to Cart',
    'Add to Wishlist',
    'Initiate Checkout',
    'Search',
];
exports.ConversionEventToPixelId = {
    Generic: 1,
    'App Install': 3,
    Purchase: 4,
    'Generate Lead': 5,
    'Complete Registration': 6,
    'Add Payment Info': 7,
    'Add to Cart': 8,
    'Add to Wishlist': 9,
    'Initiate Checkout': 10,
    Search: 11,
};
/**
 * Note: PA stands for Promoted Answer
 */
exports.QUORA_OPT_CREATIVE_TYPE = ['Image', 'Video', 'Text', 'PA'];
exports.QUORA_OPT_CTA = [
    'Learn More',
    'Get the App',
    'Apply Now',
    'Book Now',
    'Contact Us',
    'Donate Now',
    'Download',
    'Shop Now',
    'Sign Up',
    'Watch More',
    'Get Quote',
    'Follow Us',
    'Play Now',
    'Start Now',
    'Free Trial',
    'Read More',
];
exports.QUORA_OPT_DEVICE_AND_BROWSER = [
    // Don't want "Mobile & Desktop" option,
    // because it can corrupt the data
    'Mobile & Desktop',
    'All Mobile Devices',
    'iOS',
    'Android',
    'Others',
    'All Desktop Browsers',
    'Chrome',
    'Firefox',
    'Safari',
    'Others',
];
exports.QUORA_OPT_PLACEMENT = [
    'All Placements',
    'Feed',
    'Questions',
    'Digest Emails',
];
exports.QUORA_OPT_TARGETING_TYPE = [
    'Contextual Topics',
    'Contextual Keywords',
    'Contextual Questions',
    'Audience',
    'Behavioral Interests',
    'Behavioral Keyword history',
    'Behavioral Question history',
    'Behavioral Answer history',
    'Broad',
];
exports.DeviceAndBrowserPrefixMap = new Map();
exports.DeviceAndBrowserPrefixMap.set('Mobile & Desktop', '');
exports.DeviceAndBrowserPrefixMap.set('All Mobile Devices', 'M');
exports.DeviceAndBrowserPrefixMap.set('iOS', 'M');
exports.DeviceAndBrowserPrefixMap.set('Android', 'M');
exports.DeviceAndBrowserPrefixMap.set('Others', 'M');
exports.DeviceAndBrowserPrefixMap.set('All Desktop Browsers', 'D');
exports.DeviceAndBrowserPrefixMap.set('Chrome', 'D');
exports.DeviceAndBrowserPrefixMap.set('Firefox', 'D');
exports.DeviceAndBrowserPrefixMap.set('Safari', 'D');
exports.DeviceAndBrowserPrefixMap.set('Others', 'D');
exports.PlacementPrefixMap = new Map();
exports.PlacementPrefixMap.set('All Placements', 'AP');
exports.PlacementPrefixMap.set('Digest Emails', 'E');
exports.PlacementPrefixMap.set('Feed', 'F');
exports.PlacementPrefixMap.set('Questions', 'Q');
/**
 * REGEX
 */
exports.ANSWER_REGEX = /name:"AnswerRetargetingPanel_Query",selections.*?(?=id:"(\w+)")/gm;
exports.AUDIENCE_REGEX = /\\"audiences\\":(\[[^\]]*])/gm;
exports.PAUSE_HASH_REGEX = /name:"EntityStatusSwitch_adEntityTogglePause_Mutation",selections.*?(?=id:"(\w+)")/gm;
exports.CREATE_AD_HASH_REGEX = /name:"useManageAd_adCreate_Mutation",selections.*?(?=id:"(\w+)")/gm;
exports.EDIT_AD_HASH_REGEX = /name:"useManageAd_adEdit_Mutation",selections.*?(?=id:"(\w+)")/gm;
exports.EDIT_ADSET_HASH_REGEX = /name:"AdSetManageLoadable_adSetEdit_Mutation",selections.*?(?=id:"(\w+)")/gm;
exports.CREATE_AD_SET_HASH_REGEX = /name:"AdSetManageLoadable_adSetCreate_Mutation",selections.*?(?=id:"(\w+)")/gm;
exports.CREATE_CAMPAIGN_HASH_REGEX = /name:"AdCampaignManageLoadable_adCampaignCreate_Mutation",selections.*?(?=id:"(\w+)")/gm;
exports.PUBLISH_AD_HASH_REGEX = /name:"useAdReviewPage_adReviewStartCampaign_Mutation",selections.*?(?=id:"(\w+)")/gm;
exports.SEARCH_HASH_REGEX = /id:"([^"]*)"[^|]*,name:"AdsManagerSearchBarQuery"/gm;
exports.SEARCH_LOCATION_HASH_REGEX = /name:"GeolocationMultiSelectorQuery",selections.*?(?=id:"(\w+)")/gm;
exports.SEARCH_HAS_SUGGESTED_BID_REGEX = /id:"([^"]*)"[^|]*,name:"SuggestedBidQuery"/gm;
exports.SEARCH_TOPIC_HASH_REGEX = /name:"TopicSelectStepQuery",selections.*?(?=id:"(\w+)")/gm;
exports.SEARCH_QUESTION_HASH_REGEX = /name:"QuestionSelectStepQuery",selections.*?(?=id:"(\w+)")/gm;
/**
 * ADMIN ACTION TYPES
 */
exports.EDIT_AD_URL = 'https://www.quora.com/graphql/gql_POST?q=useManageAd_adEdit_Mutation';
exports.EDIT_ADSET_URL = 'https://www.quora.com/graphql/gql_POST?q=AdSetManageLoadable_adSetEdit_Mutation';
exports.CREATE_AD_URL = 'https://www.quora.com/graphql/gql_POST?q=useManageAd_adCreate_Mutation';
exports.CREATE_AD_SET_URL = 'https://www.quora.com/graphql/gql_POST?q=AdSetManageLoadable_adSetCreate_Mutation';
exports.CREATE_CAMPAIGN_URL = 'https://www.quora.com/graphql/gql_POST?q=AdCampaignManageLoadable_adCampaignCreate_Mutation';
exports.PUBLISH_AD_URL = 'https://www.quora.com/graphql/gql_POST?q=useAdReviewPage_adReviewStartCampaign_Mutation';
exports.SEARCH_LOCATION_URL = 'https://www.quora.com/graphql/gql_POST?q=GeolocationMultiSelectorQuery';
exports.SEARCH_TOPIC_URL = 'https://www.quora.com/graphql/gql_POST?q=TopicSelectStepQuery';
exports.SEARCH_QUESTION_URL = 'https://www.quora.com/graphql/gql_POST?q=QuestionSelectStepQuery';
exports.PAUSE_AD_URL = 'https://www.quora.com/graphql/gql_POST?q=EntityStatusSwitch_adEntityTogglePause_Mutation';
exports.VALIDATE_ANSWER_URL = 'https://www.quora.com/graphql/gql_POST?q=AnswerRetargetingPanel_Query';
const FORMKEY_URL = (entityId, entityType) => {
    let path;
    switch (entityType) {
        case 'account':
            path = 'account';
            break;
        default:
            /**
             * This is to account for the underscore in the entity type:
             * ad_set -> adset_performance
             * campaign -> campaign_performance
             * ad -> ad_performance
             */
            path = entityType.replace('_', '') + '_performance';
            break;
    }
    return `https://www.quora.com/ads/${path}?id=${entityId}`;
};
exports.FORMKEY_URL = FORMKEY_URL;
/**
 * Applies to both searchHash and pauseHash
 * See JMeter plan to refresh memory on how this works
 */
const HASH_URL = (webpackDomain, webpackPath) => `https://${webpackDomain}/${webpackPath}`;
exports.HASH_URL = HASH_URL;
exports.quoraHeaders = {
    accept: '*/*',
    'accept-language': 'en-GB,en;q=0.5',
    'cache-control': 'no-cache',
    'content-type': 'application/json',
    priority: 'u=1, i',
    // If somehow the single ad creation doesnt work, update below headers
    // quora-window-id, quora-broadcast-id, quora-revision
    'quora-broadcast-id': 'main-w-chan102-8888-react_zoskmmwklpgmgsxl-HePK',
    'quora-canary-revision': 'false',
    pragma: 'no-cache',
    'sec-ch-ua': '"Not_A Brand";v="8", "Chromium";v="120", "Brave";v="120"',
    'sec-ch-ua-mobile': '?0',
    'sec-ch-ua-platform': '"Windows"',
    'sec-fetch-dest': 'empty',
    'sec-fetch-mode': 'cors',
    'sec-fetch-site': 'same-origin',
    'sec-gpc': '1',
};
const defaultQuery = {
    queryName: '',
    variables: {},
    extensions: {},
};
/**
 * Requires:
 * @todo
 */
exports.createAdBody = {
    ...defaultQuery,
    queryName: 'useManageAd_adCreate_Mutation',
};
exports.editAdBody = {
    ...defaultQuery,
    queryName: 'useManageAd_adEdit_Mutation',
};
exports.editAdSetBody = {
    ...defaultQuery,
    queryName: 'AdSetManageLoadable_adSetEdit_Mutation',
};
exports.createAdSetBody = {
    ...defaultQuery,
    queryName: 'AdSetManageLoadable_adSetCreate_Mutation',
};
exports.createCampaignBody = {
    ...defaultQuery,
    queryName: 'AdCampaignManageLoadable_adCampaignCreate_Mutation',
};
/**
 * Requires:
 * - variables.entityId
 * - variables.entityType
 * - variables.pause
 * - extensions.hash
 */
exports.pauseBody = {
    ...defaultQuery,
    queryName: 'EntityStatusSwitch_adEntityTogglePause_Mutation',
};
/**
 * Requires:
 * @todo
 */
exports.publishAdBody = {
    ...defaultQuery,
    queryName: 'useAdReviewPage_adReviewStartCampaign_Mutation',
};
exports.searchLocationBody = {
    ...defaultQuery,
    queryName: 'GeolocationMultiSelectorQuery',
};
exports.searchTopicBody = {
    ...defaultQuery,
    queryName: 'TopicSelectStepQuery',
};
exports.searchQuestionBody = {
    ...defaultQuery,
    queryName: 'QuestionSelectStepQuery',
};
exports.answerBody = {
    ...defaultQuery,
    queryName: 'AnswerRetargetingPanel_Query',
};
/**
 * Requires:
 * - variables.query
 * - variables.adAccountId
 * - extensions.hash
 */
exports.searchBody = {
    ...defaultQuery,
    queryName: 'AdsManagerSearchBarQuery',
};
exports.suggestedBidBody = {
    ...defaultQuery,
    queryName: 'SuggestedBidQuery',
};
exports.QuoraDeliveryMap = new Map();
exports.QuoraDeliveryMap.set('delivering', ['delivering', 'Delivering']);
exports.QuoraDeliveryMap.set('ad_disabled', ['paused', 'Ad disabled']);
exports.QuoraDeliveryMap.set('ad_set_disabled', ['paused', 'Ad Set disabled']);
exports.QuoraDeliveryMap.set('campaign_disabled', ['paused', 'Campaign disabled']);
exports.QuoraDeliveryMap.set('not_found', ['not_found', 'Not found']);
exports.QuoraDeliveryMap.set('loading', ['loading', 'Loading']);
exports.QuoraDeliveryMap.set('account_suspended', [
    'account_suspended',
    'Account suspended',
]);
exports.QuoraDeliveryMap.set(undefined, ['no_data', 'No data']);
exports.QuoraAdTypes = [
    'image_ad',
    'promoted_answer',
    'text_ad',
    'video_ad',
];
const QuoraCTAEnums = [
    'learn_more',
    'get_the_app',
    'apply_now',
    'book_now',
    'contact_us',
    'donate_now',
    'download',
    'shop_now',
    'sign_up',
    'watch_more',
    'get_quote',
    'follow_us',
    'play_now',
    'start_now',
    'free_trial',
    'read_more',
];
// These enums are all based on careful analysis of the Quora API
var Browser;
(function (Browser) {
    Browser[Browser["Chrome"] = 0] = "Chrome";
    Browser[Browser["Firefox"] = 1] = "Firefox";
    Browser[Browser["Safari"] = 2] = "Safari";
    Browser[Browser["Others"] = 3] = "Others";
})(Browser || (exports.Browser = Browser = {}));
var Gender;
(function (Gender) {
    Gender[Gender["Unknown"] = 0] = "Unknown";
    Gender[Gender["Male"] = 1] = "Male";
    Gender[Gender["Female"] = 2] = "Female";
})(Gender || (exports.Gender = Gender = {}));
var MobileDevice;
(function (MobileDevice) {
    MobileDevice[MobileDevice["iOS"] = 1] = "iOS";
    MobileDevice[MobileDevice["Android"] = 2] = "Android";
    MobileDevice[MobileDevice["Others"] = 4] = "Others";
})(MobileDevice || (exports.MobileDevice = MobileDevice = {}));
var Placement;
(function (Placement) {
    Placement[Placement["All"] = 0] = "All";
    Placement[Placement["Questions"] = 1] = "Questions";
    Placement[Placement["Feed"] = 2] = "Feed";
    Placement[Placement["Emails"] = 3] = "Emails";
})(Placement || (exports.Placement = Placement = {}));
exports.InputTitles = [
    'Ad Delivery',
    'Ad ID',
    'Ad Name',
    'AdSet',
    'AdSet Offer',
    'AdSet Geo',
    'Advertiser',
    'Bid Amount ($US)',
    'Brand Logo',
    'Business Name',
    'Campaign',
    'Campaign Geo',
    'Campaign Offer',
    'Conversion Event',
    'Conversion Objective',
    'Copy Description',
    'Creative Asset URL',
    'Creative Type',
    'CTA',
    'Daily Budget ($US)',
    'Date Launched',
    'Device & Browser',
    'Excluded Locations',
    'Female',
    'Headline',
    'Headline Description',
    'Sub Headline Description',
    'Sub Headline',
    'Included Locations',
    'Lifetime Budget ($US)',
    'Answer',
    'Question',
    /**
     * Commented out purposefully.  Leave here in case
     * Landing Page logic changes again in future.
     */
    // 'Landing Page URL',
    // 'Landing Page Name',
    'Male',
    'Network',
    'Placement',
    'Status',
    'Sub-Vertical',
    'Targeting Theme',
    'Targeting Description',
    'Targeting Type',
    'Tracker URLs',
    'Unknown',
    'Vertical',
];
/**
 * Test-C005-003DF-7044029843930dhmKibf
 * KEEP ON
 * [Targeting Theme]
 * [Targeting Type]
 * [Device+Browser]
 * [Placement]
 * [Headline Description]
 * [Image Name OR “Text”]
 * [CTA]
 * [Landing Page Name]
 * [Brand/Business Name]
 * [Creation Date - MM/DD/YY]
 */
/**
 * Test-C005-003DF-7044029843930dhmKibf
 * KEEP ON
 * [Headline Description]
 * [Subline Description]
 * [Image Name OR “Text”]
 * [CTA]
 * [Landing Page Name]
 * [Brand/Business Name]
 * [Creation Date - MM/DD/YY]
 * @param campaignName
 * @param adSetName
 * @param adId
 * @constructor
 */
const AD_NAME_TEMPLATE = (campaignName, adSetName, adId) => [
    [campaignName, adSetName, adId],
    [
        (ad) => ad.statusGuidance || 'UNTESTED',
        (ad) => ad.headlineDescription,
        (ad) => ad.subHeadlineDescription,
        (ad) => {
            var _a, _b;
            return ad.creativeType == 'Image'
                ? (((_a = ad.image) === null || _a === void 0 ? void 0 : _a.name) || '')
                : ad.creativeType == 'Video'
                    ? (((_b = ad.video) === null || _b === void 0 ? void 0 : _b.name) || '')
                    : ad.creativeType;
        },
        (ad) => ad.cta,
        (ad) => { var _a; return ((_a = ad.landingPage) === null || _a === void 0 ? void 0 : _a.name) || ''; },
        (ad) => ad.businessName,
        (ad) => ad.launchDate,
        (ad) => { var _a; return ((_a = ad.adSet) === null || _a === void 0 ? void 0 : _a.deviceAndBrowser) || ''; },
        (ad) => { var _a; return ((_a = ad.adSet) === null || _a === void 0 ? void 0 : _a.targetingTheme) || ''; },
    ],
];
exports.AD_NAME_TEMPLATE = AD_NAME_TEMPLATE;
/**
 * Test-C005-003DF
 * KEEP ON
 * [Targeting Theme]
 * [Targeting Type]
 * [Targeting Description]
 * [Device+Browser]
 * [Placement]
 * [Offer]
 * [Creation Date - MM/DD/YY]
 * @param campaignName
 * @param adSetName
 * @constructor
 */
const AD_SET_NAME_TEMPLATE = (campaignName, adSetName) => [
    [campaignName, adSetName],
    [
        'Status',
        // 'Targeting Theme',
        'Targeting Type',
        // 'Sample Target',
        'Device & Browser',
        'Placement',
        'AdSet Offer',
        'AdSet Geo',
        'Date Launched',
    ],
];
exports.AD_SET_NAME_TEMPLATE = AD_SET_NAME_TEMPLATE;
const CAMPAIGN_NAME_TEMPLATE = (campaignName) => [
    [campaignName],
    [
        'Status',
        'Device & Browser',
        'Placement',
        'Campaign Offer',
        'Campaign Geo',
        'Vertical',
        'Conversion Objective',
        'Conversion Event',
        'Date Launched',
    ],
];
exports.CAMPAIGN_NAME_TEMPLATE = CAMPAIGN_NAME_TEMPLATE;
//# sourceMappingURL=types.js.map